import formatPhoneNumber from 'src/compass/shared/util/formatPhoneNumber';
import getCasTableCellValue from '../getCasTableCellValue';
import ICasRenderCellProps from '../ICasRenderCellProps';

export function CasRenderPhoneNumber(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);

  return !!value && formatPhoneNumber(value);
}
